import { FC } from "react";

export const DashboardIcon: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0007 15.1663C13.6207 15.1663 15.1673 13.6197 15.1673 9.99967V5.99967C15.1673 2.37967 13.6207 0.833008 10.0007 0.833008H6.00065C2.38065 0.833008 0.833984 2.37967 0.833984 5.99967V9.99967C0.833984 13.6197 2.38065 15.1663 6.00065 15.1663H10.0007ZM1.83398 5.99967C1.83398 2.92634 2.92732 1.83301 6.00065 1.83301H10.0007C13.074 1.83301 14.1673 2.92634 14.1673 5.99967V9.99967C14.1673 13.073 13.074 14.1663 10.0007 14.1663H6.00065C2.92732 14.1663 1.83398 13.073 1.83398 9.99967V5.99967ZM6.66732 11.833H8.00065H9.33398C10.714 11.833 11.834 10.713 11.834 9.33301V7.99967V6.66634C11.834 5.28634 10.714 4.16634 9.33398 4.16634H8.00065H6.66732C5.28732 4.16634 4.16732 5.28634 4.16732 6.66634V7.99967V9.33301C4.16732 10.713 5.28732 11.833 6.66732 11.833ZM5.16732 7.49967V6.66634C5.16732 5.83967 5.84065 5.16634 6.66732 5.16634H7.50065V7.49967H5.16732ZM5.16732 8.49967H7.50065V10.833H6.66732C5.84065 10.833 5.16732 10.1597 5.16732 9.33301V8.49967ZM8.50065 8.49967V10.833H9.33398C10.1607 10.833 10.834 10.1597 10.834 9.33301V8.49967H8.50065ZM10.834 7.49967V6.66634C10.834 5.83967 10.1607 5.16634 9.33398 5.16634H8.50065V7.49967H10.834Z"
    />
  </svg>
);
